
class ShareShareApplicationController {

    static $inject = ['shareApplication']
    constructor(public shareApplication) {}        
}

angular
    .module('app')
    .controller('ShareShareApplicationController', ShareShareApplicationController)